// Содержание таблиц для 4 класса (по фотографиям буклета «Введение в мир музыки»).

const TABLE_CONTENT_4_DISK1 = [
    {
        num: 0,
        authorTitle: 'ЛЕГЕНДЫ О МУЗЫКЕ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'ЛЕГЕНДЫ О МУЗЫКЕ', indentLevel: 0 }],
    },
    {
        num: 1,
        authorTitle: 'Глюк. Опера «Орфей»:',
        performer: 'Симф. орк. Берлинского радио',
        tracks: [
            { trackNum: 2, duration: '1:21' }, { trackNum: 4, duration: '1:35' }, { trackNum: 6, duration: '2:08' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Хор друзей Эвридики', trackNum: 2, duration: '1:21', indentLevel: 1 },
            { type: 'track', section: 'Хор и пляска фурий', trackNum: 4, duration: '1:35', indentLevel: 1 },
            { type: 'track', section: 'Сцена в полях Элизиума', trackNum: 6, duration: '2:08', indentLevel: 1 },
        ],
    },
    {
        num: 2,
        authorTitle: 'Римский-Корсаков. Опера «Садко»:',
        performer: 'Хор и орк. Большого театра Дир. Н. Голованов',
        tracks: [
            { trackNum: 8, duration: '1:27' }, { trackNum: 10, duration: '2:03' }, { trackNum: 12, duration: '1:19' },
            { trackNum: 14, duration: '0:34' }, { trackNum: 16, duration: '0:27' }, { trackNum: 18, duration: '1:00' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Песня Садко «Кабы была у меня золота казна»', trackNum: 8, duration: '1:27', indentLevel: 1 },
            { type: 'track', section: 'Песня Садко «Ой, ты темная дубравушка!»', trackNum: 10, duration: '2:03', indentLevel: 1 },
            { type: 'track', section: 'Песня Варяжского гостя', trackNum: 12, duration: '1:19', indentLevel: 1 },
            { type: 'track', section: 'Песня Индийского гостя', trackNum: 14, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Песня Веденецкого гостя', trackNum: 16, duration: '0:27', indentLevel: 1 },
            { type: 'track', section: 'Песня Садко с хором «Высота»', trackNum: 18, duration: '1:00', indentLevel: 1 },
        ],
    },
    {
        num: 0,
        authorTitle: 'МУЗЫКАЛЬНЫЙ ЯЗЫК',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКАЛЬНЫЙ ЯЗЫК', indentLevel: 0 }],
    },
    {
        num: 3,
        authorTitle: 'Чайковский. Балет «Спящая красавица». Интродукция:',
        performer: 'Симф. нац. орк. филарм. Варшавы, дир. Ровиски',
        tracks: [
            { trackNum: 20, duration: '0:46' }, { trackNum: 22, duration: '0:27' }, { trackNum: 24, duration: '0:24' },
            { trackNum: 26, duration: '0:24' }, { trackNum: 28, duration: '0:40' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Тема феи Карабос', trackNum: 20, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Тема феи Сирени', trackNum: 22, duration: '0:27', indentLevel: 1 },
            { type: 'track', section: 'Тема феи Сирени у флейты и английского рожка,', trackNum: 24, duration: '0:24', indentLevel: 1 },
            { type: 'track', section: 'у скрипок, у медно-', trackNum: 26, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'духовых инструментов.', trackNum: 28, duration: '0:40', indentLevel: 2 },
        ],
    },
    {
        num: 4,
        authorTitle: 'Крылатов. Песня «Крылатые качели»',
        performer: 'Хор под управлением Попова',
        tracks: [{ trackNum: 30, duration: '0:33' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Крылатые качели»', trackNum: 30, duration: '0:33', indentLevel: 1 },
        ],
    },
    {
        num: 5,
        authorTitle: 'Гаврилин. Песня «Мама»:',
        performer: 'В. Черных, Хор под управлением Попова',
        tracks: [{ trackNum: 32, duration: '1:02' }, { trackNum: 34, duration: '0:31' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'мелодия песни a cappella', trackNum: 32, duration: '1:02', indentLevel: 1 },
            { type: 'track', section: 'с сопровождением', trackNum: 34, duration: '0:31', indentLevel: 1 },
        ],
    },
    {
        num: 6,
        authorTitle: 'Римский-Корсаков. Опера «Садко»:',
        performer: 'Хор и орк. Большого театра Дир. Н. Голованов',
        tracks: [{ trackNum: 36, duration: '0:50' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'тема превращения лебедушек в красных девиц', trackNum: 36, duration: '0:50', indentLevel: 1 },
        ],
    },
    {
        num: 7,
        authorTitle: 'Бах. Прелюдия до мажор, І том ХТК',
        performer: 'Рихтер С.',
        tracks: [{ trackNum: 38, duration: '1:58' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Бах. Прелюдия до мажор, І том ХТК', trackNum: 38, duration: '1:58', indentLevel: 0 },
        ],
    },
    {
        num: 8,
        authorTitle: 'Прокофьев. «Паника»',
        performer: 'И. Кадомцев',
        tracks: [{ trackNum: 40, duration: '0:15' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Прокофьев. «Паника»', trackNum: 40, duration: '0:15', indentLevel: 0 },
        ],
    },
    {
        num: 9,
        authorTitle: 'Равель. «Болеро»',
        performer: 'Симф. орк. Люблянского радио. Дир. Нанут А.',
        tracks: [{ trackNum: 42, duration: '0:50' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Равель. «Болеро»', trackNum: 42, duration: '0:50', indentLevel: 0 },
        ],
    },
    {
        num: 10,
        authorTitle: 'Свиридов. «Весна и осень»:',
        performer: 'Гос. академ. симф. орк. СССР. Дир. Е. Светланов',
        tracks: [{ trackNum: 44, duration: '0:57' }, { trackNum: 46, duration: '1:10' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Весна', trackNum: 44, duration: '0:57', indentLevel: 1 },
            { type: 'track', section: 'Осень', trackNum: 46, duration: '1:10', indentLevel: 1 },
        ],
    },
    {
        num: 11,
        authorTitle: 'Прокофьев. «Петя и волк»:',
        performer: 'Новый Лондонский орк. Дир. Корп Р.',
        tracks: [
            { trackNum: 47, duration: '1:50' }, { trackNum: 48, duration: '0:34' }, { trackNum: 49, duration: '0:35' },
            { trackNum: 50, duration: '0:34' }, { trackNum: 51, duration: '0:26' }, { trackNum: 52, duration: '0:44' },
            { trackNum: 53, duration: '0:29' }, { trackNum: 54, duration: '0:42' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Тема Пети', trackNum: 47, duration: '1:50', indentLevel: 1 },
            { type: 'track', section: 'Тема Птички', trackNum: 48, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Тема Утки', trackNum: 49, duration: '0:35', indentLevel: 1 },
            { type: 'track', section: 'Тема Кошки', trackNum: 50, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Тема Дедушки', trackNum: 51, duration: '0:26', indentLevel: 1 },
            { type: 'track', section: 'Тема Волка', trackNum: 52, duration: '0:44', indentLevel: 1 },
            { type: 'track', section: 'Тема Охотников', trackNum: 53, duration: '0:29', indentLevel: 1 },
            { type: 'track', section: 'Окончание сказки', trackNum: 54, duration: '0:42', indentLevel: 1 },
        ],
    },
    {
        num: 12,
        authorTitle: 'Римский-Корсаков. «Три чуда»:',
        performer: 'Гос. академ. симф. орк. СССР. Дир. Е. Светланов',
        tracks: [
            { trackNum: 56, duration: '0:11' }, { trackNum: 58, duration: '0:35' }, { trackNum: 60, duration: '1:08' },
            { trackNum: 62, duration: '1:03' }, { trackNum: 64, duration: '0:48' }, { trackNum: 66, duration: '0:37' },
            { trackNum: 68, duration: '1:46' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Фанфара', trackNum: 56, duration: '0:11', indentLevel: 1 },
            { type: 'track', section: 'Тема волшебного города', trackNum: 58, duration: '0:35', indentLevel: 1 },
            { type: 'track', section: 'Леденца', trackNum: 60, duration: '1:08', indentLevel: 1 },
            { type: 'track', section: 'Тема Белки', trackNum: 62, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'Тема моря', trackNum: 64, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'Первая тема Царевны - Лебеди', trackNum: 66, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема Царевны - Лебеди', trackNum: 68, duration: '1:46', indentLevel: 1 },
        ],
    },
    {
        num: 13,
        authorTitle: 'Бриттен. «Путеводитель по оркестру для молодежи» («Вариации на тему Г. Перселла»).',
        performer: 'Лондонский симф. орк. Дир. Превин А.',
        tracks: [{ trackNum: 70, duration: '0:39' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Тема вариаций', trackNum: 70, duration: '0:39', indentLevel: 1 },
        ],
    },
    {
        num: 0,
        authorTitle: 'МУЗЫКАЛЬНЫЕ ФОРМЫ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКАЛЬНЫЕ ФОРМЫ', indentLevel: 0 }],
    },
    {
        num: 14,
        authorTitle: 'Чайковский. «Детский альбом»:',
        performer: 'Плетнев М.',
        tracks: [
            { trackNum: 72, duration: '0:31' }, { trackNum: 74, duration: '0:30' }, { trackNum: 76, duration: '0:37' },
            { trackNum: 78, duration: '0:46' }, { trackNum: 80, duration: '0:46' }, { trackNum: 82, duration: '0:37' },
            { trackNum: 84, duration: '0:33' }, { trackNum: 86, duration: '0:16' }, { trackNum: 88, duration: '0:34' },
            { trackNum: 90, duration: '0:37' }, { trackNum: 92, duration: '1:15' }, { trackNum: 94, duration: '0:33' },
            { trackNum: 96, duration: '0:52' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Утренняя молитва:', indentLevel: 1 },
            { type: 'track', section: 'первое предложение', trackNum: 72, duration: '0:31', indentLevel: 2 },
            { type: 'track', section: 'второе предложение', trackNum: 74, duration: '0:30', indentLevel: 2 },
            { type: 'track', section: 'кода', trackNum: 76, duration: '0:37', indentLevel: 2 },
            { type: 'track', section: 'В церкви', trackNum: 78, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Болезнь куклы', trackNum: 80, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Похороны куклы', trackNum: 82, duration: '0:37', indentLevel: 1 },
            { type: 'subheading', section: 'Вальс:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 84, duration: '0:33', indentLevel: 2 },
            { type: 'track', section: 'средняя часть', trackNum: 86, duration: '0:16', indentLevel: 2 },
            { type: 'track', section: 'Новая кукла', trackNum: 88, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Русская песня', trackNum: 90, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Мужик на гармонике играет', trackNum: 92, duration: '1:15', indentLevel: 1 },
            { type: 'track', section: 'Камаринская', trackNum: 94, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: 'Немецкая песенка', trackNum: 96, duration: '0:52', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_4_DISK2 = [
    {
        num: 0,
        authorTitle: 'МУЗЫКА И СЛОВО',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКА И СЛОВО', indentLevel: 0 }],
    },
    {
        num: 0,
        authorTitle: 'ПЕСНЯ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'ПЕСНЯ', indentLevel: 0 }],
    },
    {
        num: 14,
        authorTitle: 'Чайковский. «Детский альбом» (продолжение):',
        performer: 'Плетнев М.',
        tracks: [
            { trackNum: 2, duration: '0:19' }, { trackNum: 4, duration: '0:19' }, { trackNum: 6, duration: '0:19' },
            { trackNum: 8, duration: '0:44' }, { trackNum: 10, duration: '0:53' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Нянина сказка: 1 часть', trackNum: 2, duration: '0:19', indentLevel: 1 },
            { type: 'track', section: 'средняя часть', trackNum: 4, duration: '0:19', indentLevel: 1 },
            { type: 'track', section: 'реприза', trackNum: 6, duration: '0:19', indentLevel: 1 },
            { type: 'track', section: 'Баба - Яга', trackNum: 8, duration: '0:44', indentLevel: 1 },
            { type: 'track', section: 'Сладкая греза', trackNum: 10, duration: '0:53', indentLevel: 1 },
        ],
    },
    {
        num: 15,
        authorTitle: 'Веснянки:',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 12, duration: '0:18' }, { trackNum: 14, duration: '0:25' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Нам весну гукать»', trackNum: 12, duration: '0:18', indentLevel: 1 },
            { type: 'track', section: '«Весна красна»', trackNum: 14, duration: '0:25', indentLevel: 1 },
        ],
    },
    {
        num: 16,
        authorTitle: 'Колядки:',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 16, duration: '0:13' }, { trackNum: 18, duration: '0:13' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Зазимка - зима»', trackNum: 16, duration: '0:13', indentLevel: 1 },
            { type: 'track', section: '«Щедровочка»', trackNum: 18, duration: '0:13', indentLevel: 1 },
        ],
    },
    {
        num: 17,
        authorTitle: 'Былины:',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 20, duration: '0:19' }, { trackNum: 22, duration: '0:22' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Во царствии стольном Киеве»', trackNum: 20, duration: '0:19', indentLevel: 1 },
            { type: 'track', section: '«Жил Святослав»', trackNum: 22, duration: '0:22', indentLevel: 1 },
        ],
    },
    {
        num: 18,
        authorTitle: 'Исторические песни:',
        performer: 'С. Москвичева',
        tracks: [
            { trackNum: 24, duration: '2:47' }, { trackNum: 26, duration: '0:27' }, { trackNum: 28, duration: '0:44' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Как за речкою»', trackNum: 24, duration: '2:47', indentLevel: 1 },
            { type: 'track', section: '«Ты взойди, солнце красное»', trackNum: 26, duration: '0:27', indentLevel: 1 },
            { type: 'track', section: '«Из-за острова на стрежень»', trackNum: 28, duration: '0:44', indentLevel: 1 },
        ],
    },
    {
        num: 19,
        authorTitle: 'Лирические песни:',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 30, duration: '0:33' }, { trackNum: 32, duration: '0:32' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Не одна во поле дороженька»', trackNum: 30, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: '«Не шуми, мати зеленая дубравушка»', trackNum: 32, duration: '0:32', indentLevel: 1 },
        ],
    },
    {
        num: 20,
        authorTitle: 'Шуточная песня «Журавель» / Чайковский. 2-я симфония, финал',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 34, duration: '0:18' }, { trackNum: 36, duration: '3:05' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Шуточная песня «Журавель»', trackNum: 34, duration: '0:18', indentLevel: 1 },
            { type: 'track', section: 'Чайковский. 2-я симфония, финал', trackNum: 36, duration: '3:05', indentLevel: 1 },
        ],
    },
    {
        num: 21,
        authorTitle: 'Плясовая песня «Я с комариком плясала»',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 38, duration: '0:11' }],
        rows: [
            { type: 'track', section: 'Плясовая песня «Я с комариком плясала»', trackNum: 38, duration: '0:11', indentLevel: 0 },
        ],
    },
    {
        num: 22,
        authorTitle: 'Колыбельная «За березовым пеньком»',
        performer: 'С. Москвичева',
        tracks: [{ trackNum: 40, duration: '0:19' }],
        rows: [
            { type: 'track', section: 'Колыбельная «За березовым пеньком»', trackNum: 40, duration: '0:19', indentLevel: 0 },
        ],
    },
    {
        num: 0,
        authorTitle: 'РОМАНС',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'РОМАНС', indentLevel: 0 }],
    },
    {
        num: 23,
        authorTitle: 'Шуберт. «Форель»:',
        performer: 'Лемешев С.',
        tracks: [
            { trackNum: 42, duration: '0:37' }, { trackNum: 44, duration: '0:37' }, { trackNum: 46, duration: '0:23' },
            { trackNum: 48, duration: '0:25' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1-й куплет', trackNum: 42, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: '2-й куплет', trackNum: 44, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: '3-й куплет', trackNum: 46, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: '4-й куплет', trackNum: 48, duration: '0:25', indentLevel: 1 },
        ],
    },
    {
        num: 24,
        authorTitle: 'Глинка. «Ночной смотр»',
        performer: 'Гмыря Б.',
        tracks: [{ trackNum: 50, duration: '4:26' }],
        rows: [
            { type: 'track', section: 'Глинка. «Ночной смотр»', trackNum: 50, duration: '4:26', indentLevel: 0 },
        ],
    },
    {
        num: 25,
        authorTitle: 'Мусоргский. Цикл «Детская», «В углу»',
        performer: 'Н. Дорлиак',
        tracks: [{ trackNum: 52, duration: '1:51' }],
        rows: [
            { type: 'track', section: 'Мусоргский. Цикл «Детская», «В углу»', trackNum: 52, duration: '1:51', indentLevel: 0 },
        ],
    },
    {
        num: 26,
        authorTitle: 'Беллини. Опера «Норма», ария «Casta Diva»',
        performer: 'Хор и орк. EIAR',
        tracks: [{ trackNum: 54, duration: '1:48' }],
        rows: [
            { type: 'track', section: 'Беллини. Опера «Норма», ария «Casta Diva»', trackNum: 54, duration: '1:48', indentLevel: 0 },
        ],
    },
    {
        num: 27,
        authorTitle: 'Рахманинов. Вокализ',
        performer: 'Ларина.М.',
        tracks: [{ trackNum: 56, duration: '3:43' }],
        rows: [
            { type: 'track', section: 'Рахманинов. Вокализ', trackNum: 56, duration: '3:43', indentLevel: 0 },
        ],
    },
    {
        num: 0,
        authorTitle: 'МУЗЫКА И ДВИЖЕНИЕ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКА И ДВИЖЕНИЕ', indentLevel: 0 }],
    },
    {
        num: 0,
        authorTitle: 'МАРШ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МАРШ', indentLevel: 0 }],
    },
    {
        num: 28,
        authorTitle: 'Марш Преображенского полка',
        performer: 'Орк. штаба Ленинградского военного округа. Дир. Соколов С.',
        tracks: [{ trackNum: 58, duration: '1:54' }],
        rows: [
            { type: 'track', section: 'Марш Преображенского полка', trackNum: 58, duration: '1:54', indentLevel: 0 },
        ],
    },
    {
        num: 29,
        authorTitle: 'Агапкин. «Прощание славянки»',
        performer: 'Орк. штаба Ленинградского военного округа. Дир. Соколов С.',
        tracks: [{ trackNum: 60, duration: '1:21' }],
        rows: [
            { type: 'track', section: 'Агапкин. «Прощание славянки»', trackNum: 60, duration: '1:21', indentLevel: 0 },
        ],
    },
    {
        num: 30,
        authorTitle: 'Госсек. «Скорбный марш»',
        performer: 'Аранжировка И. Кадомцева',
        tracks: [{ trackNum: 62, duration: '1:02' }],
        rows: [
            { type: 'track', section: 'Госсек. «Скорбный марш»', trackNum: 62, duration: '1:02', indentLevel: 0 },
        ],
    },
    {
        num: 31,
        authorTitle: 'Бетховен. Соната №12. «Траурный марш на смерть героя»',
        performer: 'Гилельс Э.',
        tracks: [{ trackNum: 64, duration: '1:04' }],
        rows: [
            { type: 'track', section: 'Бетховен. Соната №12. «Траурный марш на смерть героя»', trackNum: 64, duration: '1:04', indentLevel: 0 },
        ],
    },
    {
        num: 32,
        authorTitle: 'Верди. Опера «Аида», финал II действия:',
        performer: 'Хор и орк. Славянской филарм. дир. Г. П. Гмюр',
        tracks: [
            { trackNum: 66, duration: '0:24' }, { trackNum: 68, duration: '0:21' }, { trackNum: 70, duration: '0:30' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'первый марш:', indentLevel: 1 },
            { type: 'track', section: 'первая тема', trackNum: 66, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'вторая тема', trackNum: 68, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'второй марш', trackNum: 70, duration: '0:30', indentLevel: 1 },
        ],
    },
    {
        num: 33,
        authorTitle: 'Прокофьев. Марш из оперы «Любовь к трем апельсинам»',
        performer: 'Большой оркестр РТ Люксенбурга Дир. Л.де Фромент.',
        tracks: [{ trackNum: 72, duration: '1:40' }],
        rows: [
            { type: 'track', section: 'Прокофьев. Марш из оперы «Любовь к трем апельсинам»', trackNum: 72, duration: '1:40', indentLevel: 0 },
        ],
    },
    {
        num: 0,
        authorTitle: 'ТАНЦЫ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'ТАНЦЫ', indentLevel: 0 }],
    },
    {
        num: 34,
        authorTitle: 'Стравинский. «Весна священная»',
        performer: 'Орк. Славянской филармонии. Дир. Пентел К.',
        tracks: [{ trackNum: 74, duration: '1:05' }],
        rows: [
            { type: 'track', section: 'Стравинский. «Весна священная»', trackNum: 74, duration: '1:05', indentLevel: 0 },
        ],
    },
    {
        num: 35,
        authorTitle: 'Мусоргский. Гопак из оперы «Сорочинская ярмарка»',
        performer: 'Орк. Венской филармонии. Дир. В. Гергиев',
        tracks: [{ trackNum: 76, duration: '1:40' }],
        rows: [
            { type: 'track', section: 'Мусоргский. Гопак из оперы «Сорочинская ярмарка»', trackNum: 76, duration: '1:40', indentLevel: 0 },
        ],
    },
    {
        num: 36,
        authorTitle: 'Чайковский. Трепак из балета «Щелкунчик»',
        performer: 'Симф. орк. Берлинской филарм., дир. Лейтнер',
        tracks: [{ trackNum: 78, duration: '1:09' }],
        rows: [
            { type: 'track', section: 'Чайковский. Трепак из балета «Щелкунчик»', trackNum: 78, duration: '1:09', indentLevel: 0 },
        ],
    },
    {
        num: 37,
        authorTitle: 'Хачатурян. Лезгинка из балета «Гаянэ»',
        performer: 'Кливлендский симф. орк. Дир. Маазель Л.',
        tracks: [{ trackNum: 80, duration: '2:41' }],
        rows: [
            { type: 'track', section: 'Хачатурян. Лезгинка из балета «Гаянэ»', trackNum: 80, duration: '2:41', indentLevel: 0 },
        ],
    },
    {
        num: 38,
        authorTitle: 'Россини. «Тарантелла»',
        performer: 'Л. Чкония, хор и орк. Большого театра СССР. Дир. М. Эрмлер',
        tracks: [{ trackNum: 82, duration: '2:35' }],
        rows: [
            { type: 'track', section: 'Россини. «Тарантелла»', trackNum: 82, duration: '2:35', indentLevel: 0 },
        ],
    },
    {
        num: 39,
        authorTitle: 'Бах. Сицилиана',
        performer: 'Е. Кисин',
        tracks: [{ trackNum: 84, duration: '0:36' }],
        rows: [
            { type: 'track', section: 'Бах. Сицилиана', trackNum: 84, duration: '0:36', indentLevel: 0 },
        ],
    },
    {
        num: 40,
        authorTitle: 'Моцарт. Менуэт из оперы «Дон Жуан»',
        performer: 'English Chamber orchestra',
        tracks: [{ trackNum: 86, duration: '0:17' }],
        rows: [
            { type: 'track', section: 'Моцарт. Менуэт из оперы «Дон Жуан»', trackNum: 86, duration: '0:17', indentLevel: 0 },
        ],
    },
    {
        num: 41,
        authorTitle: 'Шуберт. Лендлер',
        performer: 'Кушнир М. Б.',
        tracks: [{ trackNum: 88, duration: '0:31' }],
        rows: [
            { type: 'track', section: 'Шуберт. Лендлер', trackNum: 88, duration: '0:31', indentLevel: 0 },
        ],
    },
    {
        num: 42,
        authorTitle: 'Штраус. «На прекрасном голубом Дунае»:',
        performer: 'Лондонский филарм. орк. Дир. Альфред Шольц',
        tracks: [{ trackNum: 90, duration: '1:26' }, { trackNum: 92, duration: '1:28' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 90, duration: '1:26', indentLevel: 1 },
            { type: 'track', section: 'Основная часть', trackNum: 92, duration: '1:28', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_4_DISK3 = [
    {
        num: 43,
        authorTitle: 'Штраус. «Сказки венского леса»',
        performer: 'Лондонский филарм. орк. Дир. Альфред Шольц',
        tracks: [{ trackNum: 2, duration: '1:02' }],
        rows: [
            { type: 'track', section: 'Штраус. «Сказки венского леса»', trackNum: 2, duration: '1:02', indentLevel: 0 },
        ],
    },
    {
        num: 0,
        authorTitle: 'ПРОГРАММНО-ИЗОБРАЗИТЕЛЬНАЯ МУЗЫКА',
        performer: '',
        tracks: [],
        rows: [
            { type: 'subheading', section: 'ПРОГРАММНО-ИЗОБРАЗИТЕЛЬНАЯ МУЗЫКА', indentLevel: 0 },
        ],
    },
    {
        num: 44,
        authorTitle: 'Куперен. «Сестра Моник»',
        performer: 'В. Ландовска, клавесин',
        tracks: [{ trackNum: 4, duration: '1:34' }],
        rows: [
            { type: 'track', section: 'Куперен. «Сестра Моник»', trackNum: 4, duration: '1:34', indentLevel: 0 },
        ],
    },
    {
        num: 45,
        authorTitle: 'Мусоргский. «Картинки с выставки»:',
        performer: 'Мержанов В.',
        tracks: [{ trackNum: 6, duration: '1:28' }, { trackNum: 8, duration: '1:11' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Лимож. Рынок»', trackNum: 6, duration: '1:28', indentLevel: 1 },
            { type: 'track', section: '«Балет невылупившихся птенцов»', trackNum: 8, duration: '1:11', indentLevel: 1 },
        ],
    },
    {
        num: 46,
        authorTitle: 'Римский-Корсаков. «Полет шмеля»',
        performer: 'Оркестр Большого театра СССР',
        tracks: [{ trackNum: 10, duration: '1:25' }],
        rows: [
            { type: 'track', section: 'Римский-Корсаков. «Полет шмеля»', trackNum: 10, duration: '1:25', indentLevel: 0 },
        ],
    },
    {
        num: 47,
        authorTitle: 'Сен-Санс. «Карнавал животных»:',
        performer: 'Европейский фил. орк. Дир. Хемишер Гринберг',
        tracks: [
            { trackNum: 12, duration: '0:37' }, { trackNum: 14, duration: '0:33' }, { trackNum: 16, duration: '0:51' },
            { trackNum: 18, duration: '2:40' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Кенгуру', trackNum: 12, duration: '0:37', indentLevel: 1 },
            { type: 'subheading', section: 'Слон:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 14, duration: '0:33', indentLevel: 2 },
            { type: 'track', section: 'средний раздел и реприза', trackNum: 16, duration: '0:51', indentLevel: 2 },
            { type: 'track', section: 'Лебедь', trackNum: 18, duration: '2:40', indentLevel: 1 },
        ],
    },
    {
        num: 48,
        authorTitle: 'Лядов. «Баба-Яга»',
        performer: 'Гос. академ. симф. орк. СССР Дир. Светланов Е.',
        tracks: [{ trackNum: 20, duration: '1:34' }],
        rows: [
            { type: 'track', section: 'Лядов. «Баба-Яга»', trackNum: 20, duration: '1:34', indentLevel: 0 },
        ],
    },
    {
        num: 49,
        authorTitle: 'Лядов. «Кикимора»:',
        performer: 'Гос. академ. симф. орк. СССР Дир. Светланов Е.',
        tracks: [
            { trackNum: 22, duration: '0:47' }, { trackNum: 24, duration: '0:25' }, { trackNum: 26, duration: '0:12' },
            { trackNum: 28, duration: '0:21' }, { trackNum: 30, duration: '0:17' }, { trackNum: 32, duration: '0:42' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Вступление:', indentLevel: 1 },
            { type: 'track', section: 'Тема виолончелей и контрабасов', trackNum: 22, duration: '0:47', indentLevel: 2 },
            { type: 'track', section: 'Песенка кота-баюна', trackNum: 24, duration: '0:25', indentLevel: 2 },
            { type: 'track', section: 'Лейтинтонация Кикиморы', trackNum: 26, duration: '0:12', indentLevel: 2 },
            { type: 'track', section: 'Тема челесты', trackNum: 28, duration: '0:21', indentLevel: 1 },
            { type: 'track', section: 'Скерцо', trackNum: 30, duration: '0:17', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 32, duration: '0:42', indentLevel: 1 },
        ],
    },
    {
        num: 0,
        authorTitle: 'МУЗЫКА И ТЕАТР',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКА И ТЕАТР', indentLevel: 0 }],
    },
    {
        num: 0,
        authorTitle: 'МУЗЫКА К ДРАМАТИЧЕСКОМУ СПЕКТАКЛЮ',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'МУЗЫКА К ДРАМАТИЧЕСКОМУ СПЕКТАКЛЮ', indentLevel: 0 }],
    },
    {
        num: 50,
        authorTitle: 'Лядов. «Волшебное озеро»',
        performer: 'Гос. академ. симф. орк. СССР Дир. Светланов Е.',
        tracks: [
            { trackNum: 34, duration: '0:37' }, { trackNum: 36, duration: '0:39' }, { trackNum: 38, duration: '0:57' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступительный раздел', trackNum: 34, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Темы-«зовы»', trackNum: 36, duration: '0:39', indentLevel: 1 },
            { type: 'track', section: 'Кульминация', trackNum: 38, duration: '0:57', indentLevel: 1 },
        ],
    },
    {
        num: 51,
        authorTitle: 'Григ. «Пер Гюнт»:',
        performer: 'Лондонский фестивальный орк. Дир. Бенгсон С.',
        tracks: [
            { trackNum: 40, duration: '0:50' }, { trackNum: 42, duration: '3:05' }, { trackNum: 44, duration: '0:57' },
            { trackNum: 46, duration: '2:08' }, { trackNum: 48, duration: '0:25' }, { trackNum: 50, duration: '0:21' },
            { trackNum: 52, duration: '0:16' }, { trackNum: 54, duration: '1:20' }, { trackNum: 56, duration: '0:39' },
            { trackNum: 58, duration: '1:02' }, { trackNum: 59, duration: '1:21' }, { trackNum: 61, duration: '0:37' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Утро:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 40, duration: '0:50', indentLevel: 2 },
            { type: 'track', section: 'кульминация', trackNum: 42, duration: '3:05', indentLevel: 2 },
            { type: 'subheading', section: 'Смерть Озе:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 44, duration: '0:57', indentLevel: 2 },
            { type: 'track', section: 'вторая часть', trackNum: 46, duration: '2:08', indentLevel: 2 },
            { type: 'subheading', section: 'Танец Анитры:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 48, duration: '0:25', indentLevel: 2 },
            { type: 'track', section: 'средний раздел', trackNum: 50, duration: '0:21', indentLevel: 2 },
            { type: 'subheading', section: 'В пещере горного короля', indentLevel: 1 },
            { type: 'track', section: 'начальная тема', trackNum: 52, duration: '0:16', indentLevel: 2 },
            { type: 'track', section: 'развитие темы, кульминация', trackNum: 54, duration: '1:20', indentLevel: 2 },
            { type: 'track', section: 'и окончание', trackNum: 56, duration: '0:39', indentLevel: 2 },
            { type: 'subheading', section: 'Песня Сольвейг', indentLevel: 1 },
            { type: 'track', section: 'оркестровое вступление', trackNum: 58, duration: '1:02', indentLevel: 2 },
            { type: 'track', section: 'запев соло', trackNum: 59, duration: '1:21', indentLevel: 2 },
            { type: 'track', section: 'запев у оркестра', trackNum: 61, duration: '0:37', indentLevel: 2 },
        ],
    },
    {
        num: 52,
        authorTitle: 'Чайковский. «Щелкунчик»:',
        performer: 'Симф. орк. Берлинской филарм., дир. Лейтнер',
        tracks: [
            { trackNum: 63, duration: '0:53' }, { trackNum: 65, duration: '1:10' }, { trackNum: 67, duration: '0:17' },
            { trackNum: 69, duration: '0:31' }, { trackNum: 71, duration: '2:32' }, { trackNum: 73, duration: '1:24' },
            { trackNum: 75, duration: '3:25' }, { trackNum: 77, duration: '1:08' }, { trackNum: 79, duration: '1:07' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Увертюра', trackNum: 63, duration: '0:53', indentLevel: 1 },
            { type: 'subheading', section: 'Марш:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 65, duration: '1:10', indentLevel: 2 },
            { type: 'track', section: 'средняя часть', trackNum: 67, duration: '0:17', indentLevel: 2 },
            { type: 'track', section: 'реприза', trackNum: 69, duration: '0:31', indentLevel: 2 },
            { type: 'track', section: 'Рост елки', trackNum: 71, duration: '2:32', indentLevel: 1 },
            { type: 'track', section: 'Сцена сражения', trackNum: 73, duration: '1:24', indentLevel: 1 },
            { type: 'subheading', section: 'Дивертисмент:', indentLevel: 1 },
            { type: 'track', section: 'Танец кофе', trackNum: 75, duration: '3:25', indentLevel: 2 },
            { type: 'track', section: 'Чай', trackNum: 77, duration: '1:08', indentLevel: 2 },
            { type: 'track', section: 'Трепак', trackNum: 79, duration: '1:07', indentLevel: 2 },
        ],
    },
];

const TABLE_CONTENT_4_DISK4 = [
    {
        num: 52,
        authorTitle: 'Чайковский. «Щелкунчик» (продолжение):',
        performer: 'Симф. орк. Берлинской филарм., дир. Лейтнер',
        tracks: [
            { trackNum: 2, duration: '2:31' }, { trackNum: 4, duration: '2:17' }, { trackNum: 6, duration: '0:17' },
            { trackNum: 8, duration: '0:32' }, { trackNum: 10, duration: '3:54' }, { trackNum: 12, duration: '1:58' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Танец 3-х пастухов', trackNum: 2, duration: '2:31', indentLevel: 1 },
            { type: 'subheading', section: 'Вальс цветов:', indentLevel: 1 },
            { type: 'track', section: 'вступление', trackNum: 4, duration: '2:17', indentLevel: 2 },
            { type: 'track', section: 'основная тема', trackNum: 6, duration: '0:17', indentLevel: 2 },
            { type: 'track', section: 'тема средней части', trackNum: 8, duration: '0:32', indentLevel: 2 },
            { type: 'track', section: 'центральный эпизод', trackNum: 10, duration: '3:54', indentLevel: 2 },
            { type: 'track', section: 'Па-де-де', trackNum: 12, duration: '1:58', indentLevel: 1 },
        ],
    },
    {
        num: 53,
        authorTitle: 'Глинка. «Руслан и Людмила»:',
        performer: 'Хор и орк. Большого театра Дир. К. Кондрашин',
        tracks: [
            { trackNum: 14, duration: '0:53' }, { trackNum: 16, duration: '0:30' }, { trackNum: 18, duration: '0:50' },
            { trackNum: 20, duration: '2:09' }, { trackNum: 22, duration: '1:41' }, { trackNum: 24, duration: '3:04' },
            { trackNum: 26, duration: '2:09' }, { trackNum: 28, duration: '2:55' }, { trackNum: 30, duration: '1:14' },
            { trackNum: 32, duration: '1:53' }, { trackNum: 34, duration: '0:21' }, { trackNum: 36, duration: '2:29' },
            { trackNum: 38, duration: '3:38' }, { trackNum: 40, duration: '3:11' }, { trackNum: 42, duration: '2:56' },
            { trackNum: 44, duration: '2:31' }, { trackNum: 48, duration: '0:37' }, { trackNum: 50, duration: '3:09' },
            { trackNum: 52, duration: '1:53' }, { trackNum: 54, duration: '1:45' }, { trackNum: 56, duration: '1:05' },
            { trackNum: 58, duration: '1:07' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Увертюра:', indentLevel: 1 },
            { type: 'track', section: 'первая тема', trackNum: 14, duration: '0:53', indentLevel: 2 },
            { type: 'track', section: 'вторая тема', trackNum: 16, duration: '0:30', indentLevel: 2 },
            { type: 'track', section: 'кода', trackNum: 18, duration: '0:50', indentLevel: 2 },
            { type: 'subheading', section: 'Интродукция.', indentLevel: 1 },
            { type: 'track', section: '«Дела давно минувших дней»', trackNum: 20, duration: '2:09', indentLevel: 2 },
            { type: 'track', section: '1-я песня Баяна', trackNum: 22, duration: '1:41', indentLevel: 2 },
            { type: 'track', section: '2-я песня Баяна', trackNum: 24, duration: '3:04', indentLevel: 2 },
            { type: 'subheading', section: 'Каватина Людмилы:', indentLevel: 1 },
            { type: 'track', section: 'первый раздел', trackNum: 26, duration: '2:09', indentLevel: 2 },
            { type: 'track', section: 'второй раздел', trackNum: 28, duration: '2:55', indentLevel: 2 },
            { type: 'subheading', section: 'Сцена похищения:', indentLevel: 1 },
            { type: 'track', section: '«гамма Черномора»', trackNum: 30, duration: '1:14', indentLevel: 2 },
            { type: 'track', section: 'и «аккорды оцепенения»', trackNum: 32, duration: '1:53', indentLevel: 2 },
            { type: 'track', section: 'канон «Какое чудное мгновенье»', trackNum: 34, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'конец 1 действия: «Где Людмила?»', trackNum: 36, duration: '2:29', indentLevel: 2 },
            { type: 'subheading', section: '2 действие.', indentLevel: 1 },
            { type: 'track', section: 'Дуэтино Фарлафа и Наины', trackNum: 38, duration: '3:38', indentLevel: 2 },
            { type: 'track', section: 'Ария-рондо Фарлафа', trackNum: 40, duration: '3:11', indentLevel: 2 },
            { type: 'track', section: 'Речитатив Руслана', trackNum: 42, duration: '2:56', indentLevel: 2 },
            { type: 'track', section: 'Ариозо Руслана «Времен от вечной темноты»', trackNum: 44, duration: '2:31', indentLevel: 2 },
            { type: 'track', section: 'Ария Руслана «Дай Перун». Сцена с Головой', trackNum: 48, duration: '0:37', indentLevel: 2 },
            { type: 'subheading', section: '3 действие.', indentLevel: 1 },
            { type: 'track', section: 'Персидский хор', trackNum: 50, duration: '3:09', indentLevel: 2 },
            { type: 'track', section: 'Ария Ратмира', trackNum: 52, duration: '1:53', indentLevel: 2 },
            { type: 'subheading', section: '4 действие.', indentLevel: 1 },
            { type: 'track', section: 'Ария Людмилы', trackNum: 54, duration: '1:45', indentLevel: 2 },
            { type: 'subheading', section: 'Марш Черномора:', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 56, duration: '1:05', indentLevel: 2 },
            { type: 'track', section: 'средняя часть', trackNum: 58, duration: '1:07', indentLevel: 2 },
        ],
    },
];

const TABLE_CONTENT_4_DISK5 = [
    {
        num: 53,
        authorTitle: 'Глинка. «Руслан и Людмила» (продолжение):',
        performer: 'Бинс М.',
        tracks: [
            { trackNum: 2, duration: '0:27' }, { trackNum: 4, duration: '2:36' }, { trackNum: 6, duration: '1:38' },
            { trackNum: 8, duration: '2:05' }, { trackNum: 10, duration: '3:11' }, { trackNum: 12, duration: '1:30' },
            { trackNum: 14, duration: '2:24' }, { trackNum: 16, duration: '1:09' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Марш Черномора- реприза', trackNum: 2, duration: '0:27', indentLevel: 1 },
            { type: 'track', section: 'Турецкий танец', trackNum: 4, duration: '2:36', indentLevel: 1 },
            { type: 'track', section: 'Арабский танец', trackNum: 6, duration: '1:38', indentLevel: 1 },
            { type: 'track', section: 'Лезгинка', trackNum: 8, duration: '2:05', indentLevel: 1 },
            { type: 'track', section: 'Хор «Погибнет...»', trackNum: 10, duration: '3:11', indentLevel: 1 },
            { type: 'subheading', section: '5 действие.', indentLevel: 1 },
            { type: 'track', section: 'Хор «Ах, ты, свет Людмила»', trackNum: 12, duration: '1:30', indentLevel: 2 },
            { type: 'track', section: 'Хор «Не проснется птичка»', trackNum: 14, duration: '2:24', indentLevel: 2 },
            { type: 'track', section: 'Хор «Слава великим Богам»', trackNum: 16, duration: '1:09', indentLevel: 2 },
        ],
    },
    {
        num: 0,
        authorTitle: 'ДЕТСКАЯ МУЗЫКА КОМПОЗИТОРОВ ХХ В.',
        performer: '',
        tracks: [],
        rows: [{ type: 'subheading', section: 'ДЕТСКАЯ МУЗЫКА КОМПОЗИТОРОВ ХХ В.', indentLevel: 0 }],
    },
    {
        num: 54,
        authorTitle: 'Дебюсси. «Детский уголок»:',
        performer: 'Бинс М.',
        tracks: [
            { trackNum: 19, duration: '1:51' }, { trackNum: 21, duration: '2:48' }, { trackNum: 23, duration: '2:14' },
            { trackNum: 25, duration: '2:27' }, { trackNum: 27, duration: '2:24' }, { trackNum: 29, duration: '2:46' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Доктор «Gradus ad Parnassum»', trackNum: 19, duration: '1:51', indentLevel: 1 },
            { type: 'track', section: 'Колыбельная Джимбо', trackNum: 21, duration: '2:48', indentLevel: 1 },
            { type: 'track', section: 'Серенада кукле', trackNum: 23, duration: '2:14', indentLevel: 1 },
            { type: 'track', section: 'Снег танцует', trackNum: 25, duration: '2:27', indentLevel: 1 },
            { type: 'track', section: 'Маленький пастух', trackNum: 27, duration: '2:24', indentLevel: 1 },
            { type: 'track', section: 'Кукольный кейкуок', trackNum: 29, duration: '2:46', indentLevel: 1 },
        ],
    },
    {
        num: 55,
        authorTitle: 'Равель. «Матушка гусыня»:',
        performer: 'Бинс М.',
        tracks: [
            { trackNum: 31, duration: '0:30' }, { trackNum: 33, duration: '2:01' }, { trackNum: 35, duration: '1:03' },
            { trackNum: 37, duration: '3:33' }, { trackNum: 39, duration: '0:45' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Павана красавице', trackNum: 31, duration: '0:30', indentLevel: 1 },
            { type: 'track', section: 'Мальчик-с-пальчик', trackNum: 33, duration: '2:01', indentLevel: 1 },
            { type: 'track', section: 'Дурнушка-императрица пагод', trackNum: 35, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'Красавица и чудовище', trackNum: 37, duration: '3:33', indentLevel: 1 },
            { type: 'track', section: 'Волшебный сад', trackNum: 39, duration: '0:45', indentLevel: 1 },
        ],
    },
    {
        num: 56,
        authorTitle: 'Барток. 10 легких пьес:',
        performer: 'Кушнир П.',
        tracks: [{ trackNum: 41, duration: '0:25' }, { trackNum: 43, duration: '0:20' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Венгерская народная песня»', trackNum: 41, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: '«Медвежий танец»', trackNum: 43, duration: '0:20', indentLevel: 1 },
        ],
    },
    {
        num: 57,
        authorTitle: 'Прокофьев. «Детская музыка»:',
        performer: 'В. Жуков',
        tracks: [
            { trackNum: 45, duration: '2:47' }, { trackNum: 46, duration: '0:46' }, { trackNum: 47, duration: '0:58' },
            { trackNum: 48, duration: '2:37' }, { trackNum: 49, duration: '2:36' }, { trackNum: 50, duration: '2:08' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Утро', trackNum: 45, duration: '2:47', indentLevel: 1 },
            { type: 'track', section: 'Прогулка', trackNum: 46, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Тарантелла', trackNum: 47, duration: '0:58', indentLevel: 1 },
            { type: 'track', section: 'Раскаяние', trackNum: 48, duration: '2:37', indentLevel: 1 },
            { type: 'track', section: 'Вечер', trackNum: 49, duration: '2:36', indentLevel: 1 },
            { type: 'track', section: 'Ходит месяц над лугами', trackNum: 50, duration: '2:08', indentLevel: 1 },
        ],
    },
    {
        num: 58,
        authorTitle: 'Свиридов. «Альбом пьес для детей»:',
        performer: 'Кушнир П.',
        tracks: [
            { trackNum: 52, duration: '0:45' }, { trackNum: 53, duration: '2:24' }, { trackNum: 54, duration: '1:11' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Ласковая просьба', trackNum: 52, duration: '0:45', indentLevel: 1 },
            { type: 'track', section: 'Грустная песня', trackNum: 53, duration: '2:24', indentLevel: 1 },
            { type: 'track', section: 'Дождик', trackNum: 54, duration: '1:11', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_4_DISK6 = [
    {
        num: 1,
        authorTitle: 'Чайковский. Балет «Спящая красавица». Интродукция',
        performer: 'Симф. нац. орк. филарм. Варшавы, дир. Ровиски',
        tracks: [{ trackNum: 2, duration: '4:27' }],
        rows: [
            { type: 'track', section: 'Чайковский. Балет «Спящая красавица». Интродукция', trackNum: 2, duration: '4:27', indentLevel: 0 },
        ],
    },
    {
        num: 2,
        authorTitle: 'Равель. Болеро',
        performer: 'Симф. орк. Люблянского радио. Дир. Нанут А.',
        tracks: [{ trackNum: 4, duration: '13:46' }],
        rows: [
            { type: 'track', section: 'Равель. Болеро', trackNum: 4, duration: '13:46', indentLevel: 0 },
        ],
    },
    {
        num: 3,
        authorTitle: 'Прокофьев. Симфоническая сказка «Петя и волк»:',
        performer: 'Лондонский симф. орк. Дир. Превин А. Текст читает автор-составитель',
        tracks: [
            { trackNum: 5, duration: '0:46' }, { trackNum: 6, duration: '0:36' }, { trackNum: 7, duration: '0:22' },
            { trackNum: 8, duration: '0:25' }, { trackNum: 9, duration: '0:23' }, { trackNum: 10, duration: '0:25' },
            { trackNum: 11, duration: '0:23' }, { trackNum: 12, duration: '24:10' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'тема Пети', trackNum: 5, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'тема Волка', trackNum: 6, duration: '0:36', indentLevel: 1 },
            { type: 'track', section: 'тема Дедушки', trackNum: 7, duration: '0:22', indentLevel: 1 },
            { type: 'track', section: 'тема охотников', trackNum: 8, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: 'тема Птички', trackNum: 9, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: 'тема Кошки', trackNum: 10, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: 'тема Утки', trackNum: 11, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: 'Сказка (читает автор-составитель)', trackNum: 12, duration: '24:10', indentLevel: 1 },
        ],
    },
    {
        num: 4,
        authorTitle: 'Римский-Корсаков. «Три чуда». Вступление ко 2-ой картине оперы «Сказка о Царе Салтане»',
        performer: 'Гос. академ. симф. орк. СССР. Дир. Е. Светланов',
        tracks: [{ trackNum: 14, duration: '4:00' }],
        rows: [
            { type: 'track', section: 'Римский-Корсаков. «Три чуда». Вступление ко 2-ой картине оперы «Сказка о Царе Салтане»', trackNum: 14, duration: '4:00', indentLevel: 0 },
        ],
    },
    {
        num: 5,
        authorTitle: 'Бриттен. «Путеводитель по оркестру для молодежи»: тема Г. Перселла',
        performer: 'Лондонский симф. орк. Дир. Превин А. Текст читает автор-составитель',
        tracks: [
            { trackNum: 16, duration: '0:28' }, { trackNum: 18, duration: '0:21' }, { trackNum: 20, duration: '0:20' },
            { trackNum: 22, duration: '0:20' }, { trackNum: 24, duration: '0:18' }, { trackNum: 26, duration: '0:24' },
            { trackNum: 28, duration: '0:55' }, { trackNum: 30, duration: '0:38' }, { trackNum: 32, duration: '0:49' },
            { trackNum: 34, duration: '0:40' }, { trackNum: 36, duration: '1:02' }, { trackNum: 38, duration: '1:13' },
            { trackNum: 40, duration: '0:56' }, { trackNum: 42, duration: '0:43' }, { trackNum: 44, duration: '0:53' },
            { trackNum: 46, duration: '0:25' }, { trackNum: 48, duration: '0:58' }, { trackNum: 50, duration: '0:17' },
            { trackNum: 52, duration: '0:11' }, { trackNum: 54, duration: '0:08' }, { trackNum: 56, duration: '0:11' },
            { trackNum: 58, duration: '0:10' }, { trackNum: 60, duration: '0:10' }, { trackNum: 62, duration: '0:21' },
            { trackNum: 64, duration: '2:41' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'тема Г. Перселла', trackNum: 16, duration: '0:28', indentLevel: 1 },
            { type: 'subheading', section: 'Вариации:', indentLevel: 1 },
            { type: 'track', section: 'деревянно-духовые инструменты', trackNum: 18, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'медно-духовые инструменты', trackNum: 20, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'струнные инструменты', trackNum: 22, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'ударные инструменты', trackNum: 24, duration: '0:18', indentLevel: 2 },
            { type: 'track', section: 'флейта', trackNum: 26, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'гобой', trackNum: 28, duration: '0:55', indentLevel: 2 },
            { type: 'track', section: 'кларнет', trackNum: 30, duration: '0:38', indentLevel: 2 },
            { type: 'track', section: 'фагот', trackNum: 32, duration: '0:49', indentLevel: 2 },
            { type: 'track', section: 'скрипки', trackNum: 34, duration: '0:40', indentLevel: 2 },
            { type: 'track', section: 'альты', trackNum: 36, duration: '1:02', indentLevel: 2 },
            { type: 'track', section: 'виолончели', trackNum: 38, duration: '1:13', indentLevel: 2 },
            { type: 'track', section: 'контрабас', trackNum: 40, duration: '0:56', indentLevel: 2 },
            { type: 'track', section: 'арфа', trackNum: 42, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: 'валторна', trackNum: 44, duration: '0:53', indentLevel: 2 },
            { type: 'track', section: 'труба', trackNum: 46, duration: '0:25', indentLevel: 2 },
            { type: 'track', section: 'тромбон и туба', trackNum: 48, duration: '0:58', indentLevel: 2 },
            { type: 'track', section: 'литавры', trackNum: 50, duration: '0:17', indentLevel: 2 },
            { type: 'track', section: 'большой барабан и тарелки', trackNum: 52, duration: '0:11', indentLevel: 2 },
            { type: 'track', section: 'тамбурин и треугольник', trackNum: 54, duration: '0:08', indentLevel: 2 },
            { type: 'track', section: 'малый барабан и китайский бок', trackNum: 56, duration: '0:11', indentLevel: 2 },
            { type: 'track', section: 'ксилофон', trackNum: 58, duration: '0:10', indentLevel: 2 },
            { type: 'track', section: 'кастаньеты и гонг', trackNum: 60, duration: '0:10', indentLevel: 2 },
            { type: 'track', section: 'бич и вся ударная группа', trackNum: 62, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'Фуга и тема Г.Перселла', trackNum: 64, duration: '2:41', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_4_DISK7 = [
    {
        num: 6,
        authorTitle: 'Чайковский. «Детский альбом»:',
        performer: 'Плетнев М.',
        tracks: [
            { trackNum: 1, duration: '1:44' }, { trackNum: 2, duration: '1:05' }, { trackNum: 3, duration: '0:42' },
            { trackNum: 4, duration: '1:15' }, { trackNum: 5, duration: '0:54' }, { trackNum: 6, duration: '2:56' },
            { trackNum: 7, duration: '2:01' }, { trackNum: 8, duration: '1:18' }, { trackNum: 9, duration: '0:38' },
            { trackNum: 10, duration: '1:09' }, { trackNum: 11, duration: '0:41' }, { trackNum: 12, duration: '1:22' },
            { trackNum: 13, duration: '0:36' }, { trackNum: 14, duration: '0:46' }, { trackNum: 15, duration: '0:57' },
            { trackNum: 16, duration: '1:30' }, { trackNum: 17, duration: '0:56' }, { trackNum: 18, duration: '1:11' },
            { trackNum: 19, duration: '0:56' }, { trackNum: 20, duration: '0:47' }, { trackNum: 21, duration: '2:38' },
            { trackNum: 22, duration: '0:58' }, { trackNum: 23, duration: '0:57' }, { trackNum: 24, duration: '3:14' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Утренняя молитва', trackNum: 1, duration: '1:44', indentLevel: 1 },
            { type: 'track', section: 'Зимнее утро', trackNum: 2, duration: '1:05', indentLevel: 1 },
            { type: 'track', section: 'Игра в лошадки', trackNum: 3, duration: '0:42', indentLevel: 1 },
            { type: 'track', section: 'Мама', trackNum: 4, duration: '1:15', indentLevel: 1 },
            { type: 'track', section: 'Марш деревянных солдатиков', trackNum: 5, duration: '0:54', indentLevel: 1 },
            { type: 'track', section: 'Болезнь куклы', trackNum: 6, duration: '2:56', indentLevel: 1 },
            { type: 'track', section: 'Похороны куклы', trackNum: 7, duration: '2:01', indentLevel: 1 },
            { type: 'track', section: 'Вальс', trackNum: 8, duration: '1:18', indentLevel: 1 },
            { type: 'track', section: 'Новая кукла', trackNum: 9, duration: '0:38', indentLevel: 1 },
            { type: 'track', section: 'Мазурка', trackNum: 10, duration: '1:09', indentLevel: 1 },
            { type: 'track', section: 'Русская песня', trackNum: 11, duration: '0:41', indentLevel: 1 },
            { type: 'track', section: 'Мужик на гармонике играет', trackNum: 12, duration: '1:22', indentLevel: 1 },
            { type: 'track', section: 'Камаринская', trackNum: 13, duration: '0:36', indentLevel: 1 },
            { type: 'track', section: 'Полька', trackNum: 14, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Итальянская песенка', trackNum: 15, duration: '0:57', indentLevel: 1 },
            { type: 'track', section: 'Старинная французская песенка', trackNum: 16, duration: '1:30', indentLevel: 1 },
            { type: 'track', section: 'Немецкая песенка', trackNum: 17, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'Неаполитанская песенка', trackNum: 18, duration: '1:11', indentLevel: 1 },
            { type: 'track', section: 'Нянина сказка', trackNum: 19, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'Баба-Яга', trackNum: 20, duration: '0:47', indentLevel: 1 },
            { type: 'track', section: 'Сладкая греза', trackNum: 21, duration: '2:38', indentLevel: 1 },
            { type: 'track', section: 'Песня жаворонка', trackNum: 22, duration: '0:58', indentLevel: 1 },
            { type: 'track', section: 'Шарманщик поет в церкви', trackNum: 23, duration: '0:57', indentLevel: 1 },
            { type: 'track', section: 'Шарманщик поет в церкви', trackNum: 24, duration: '3:14', indentLevel: 1 },
        ],
    },
    {
        num: 7,
        authorTitle: 'Шуберт. «Форель»',
        performer: 'Лемешев С.',
        tracks: [{ trackNum: 25, duration: '1:58' }],
        rows: [
            { type: 'track', section: 'Шуберт. «Форель»', trackNum: 25, duration: '1:58', indentLevel: 0 },
        ],
    },
    {
        num: 8,
        authorTitle: 'Мусоргский. «Детская»:',
        performer: 'Н. Дорлиак',
        tracks: [
            { trackNum: 26, duration: '2:25' }, { trackNum: 27, duration: '1:56' }, { trackNum: 28, duration: '2:40' },
            { trackNum: 29, duration: '2:24' }, { trackNum: 30, duration: '2:36' }, { trackNum: 31, duration: '2:11' },
            { trackNum: 32, duration: '3:30' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: '№1 «С няней»', trackNum: 26, duration: '2:25', indentLevel: 1 },
            { type: 'track', section: '№2 «В углу»', trackNum: 27, duration: '1:56', indentLevel: 1 },
            { type: 'track', section: '№3 «Жук»', trackNum: 28, duration: '2:40', indentLevel: 1 },
            { type: 'track', section: '№4 «С куклой»', trackNum: 29, duration: '2:24', indentLevel: 1 },
            { type: 'track', section: '№5 «На сон грядущий»', trackNum: 30, duration: '2:36', indentLevel: 1 },
            { type: 'track', section: '№6 «Кот-матрос»', trackNum: 31, duration: '2:11', indentLevel: 1 },
            { type: 'track', section: '№7 «Поехал на палочке»', trackNum: 32, duration: '3:30', indentLevel: 1 },
        ],
    },
    {
        num: 9,
        authorTitle: 'Беллини. Опера «Норма». Ария Нормы «Casta Diva»',
        performer: 'Хор и орк. EIAR',
        tracks: [{ trackNum: 33, duration: '6:45' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ария «Casta Diva»', trackNum: 33, duration: '6:45', indentLevel: 1 }],
    },
    {
        num: 10,
        authorTitle: 'Бетховен. Соната №12. «Траурный марш на смерть героя»',
        performer: 'Гилельс Э.',
        tracks: [{ trackNum: 34, duration: '6:31' }],
        rows: [{ type: 'title' }, { type: 'track', section: '«Траурный марш на смерть героя»', trackNum: 34, duration: '6:31', indentLevel: 1 }],
    },
    {
        num: 11,
        authorTitle: 'Верди. Опера «Аида». Финал II действия.',
        performer: 'Хор и орк. Словацкой филарм. дир. Г. П. Гмюр',
        tracks: [{ trackNum: 35, duration: '8:11' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Финал II действия', trackNum: 35, duration: '8:11', indentLevel: 1 }],
    },
];

const TABLE_CONTENT_4_DISK8 = [
    {
        num: 12,
        authorTitle: 'Стравинский. «Весна священная».',
        performer: 'Орк. славянской филармонии. Дир. Пентел К.',
        tracks: [
            { trackNum: 1, duration: '3:39' }, { trackNum: 2, duration: '3:25' }, { trackNum: 3, duration: '1:14' },
            { trackNum: 4, duration: '3:32' }, { trackNum: 5, duration: '1:43' }, { trackNum: 6, duration: '0:39' },
            { trackNum: 7, duration: '0:23' }, { trackNum: 8, duration: '1:10' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Часть 1 «Поцелуй земли»', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 1, duration: '3:39', indentLevel: 2 },
            { type: 'track', section: 'Весенние гадания. Пляски щеголих', trackNum: 2, duration: '3:25', indentLevel: 2 },
            { type: 'track', section: 'Игра умыкания', trackNum: 3, duration: '1:14', indentLevel: 2 },
            { type: 'track', section: 'Вешние хороводы', trackNum: 4, duration: '3:32', indentLevel: 2 },
            { type: 'track', section: 'Игра двух городов', trackNum: 5, duration: '1:43', indentLevel: 2 },
            { type: 'track', section: 'Шествие старейшего-мудрейшего', trackNum: 6, duration: '0:39', indentLevel: 2 },
            { type: 'track', section: 'Поцелуй земли', trackNum: 7, duration: '0:23', indentLevel: 2 },
            { type: 'track', section: 'Выплясывание земли', trackNum: 8, duration: '1:10', indentLevel: 2 },
        ],
    },
    {
        num: 13,
        authorTitle: 'Бах. Сицилиана',
        performer: 'Е. Кисин',
        tracks: [{ trackNum: 9, duration: '2:30' }],
        rows: [{ type: 'track', section: 'Бах. Сицилиана', trackNum: 9, duration: '2:30', indentLevel: 0 }],
    },
    {
        num: 14,
        authorTitle: 'Штраус. Вальс «На прекрасном голубом Дунае»',
        performer: 'Лондонский филарм. орк. Дир. Альфред Шольц',
        tracks: [{ trackNum: 10, duration: '10:06' }],
        rows: [{ type: 'track', section: 'Штраус. Вальс «На прекрасном голубом Дунае»', trackNum: 10, duration: '10:06', indentLevel: 0 }],
    },
    {
        num: 15,
        authorTitle: 'Мусоргский. «Картинки с выставки»:',
        performer: 'Мержанов В.',
        tracks: [
            { trackNum: 12, duration: '1:15' }, { trackNum: 13, duration: '2:22' }, { trackNum: 14, duration: '0:37' },
            { trackNum: 15, duration: '4:56' }, { trackNum: 16, duration: '0:25' }, { trackNum: 17, duration: '1:01' },
            { trackNum: 18, duration: '2:17' }, { trackNum: 19, duration: '0:42' }, { trackNum: 20, duration: '1:09' },
            { trackNum: 21, duration: '2:05' }, { trackNum: 22, duration: '1:16' }, { trackNum: 23, duration: '1:24' },
            { trackNum: 24, duration: '1:37' }, { trackNum: 25, duration: '2:13' }, { trackNum: 26, duration: '3:08' },
            { trackNum: 27, duration: '4:25' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Прогулка', trackNum: 12, duration: '1:15', indentLevel: 1 },
            { type: 'track', section: 'Гном', trackNum: 13, duration: '2:22', indentLevel: 1 },
            { type: 'track', section: 'Прогулка', trackNum: 14, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Старый замок', trackNum: 15, duration: '4:56', indentLevel: 1 },
            { type: 'track', section: 'Прогулка', trackNum: 16, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: 'Тюльерийский сад (ссора детей после игры)', trackNum: 17, duration: '1:01', indentLevel: 1 },
            { type: 'track', section: 'Быдло', trackNum: 18, duration: '2:17', indentLevel: 1 },
            { type: 'track', section: 'Прогулка', trackNum: 19, duration: '0:42', indentLevel: 1 },
            { type: 'track', section: 'Балет невылупившихся птенцов', trackNum: 20, duration: '1:09', indentLevel: 1 },
            { type: 'track', section: 'Два еврея: богатый и бедный', trackNum: 21, duration: '2:05', indentLevel: 1 },
            { type: 'track', section: 'Прогулка', trackNum: 22, duration: '1:16', indentLevel: 1 },
            { type: 'track', section: 'Лимож. Рынок (Большая новость)', trackNum: 23, duration: '1:24', indentLevel: 1 },
            { type: 'track', section: 'Катакомбы (Римская гробница)', trackNum: 24, duration: '1:37', indentLevel: 1 },
            { type: 'track', section: 'С мертвыми на мертвом языке', trackNum: 25, duration: '2:13', indentLevel: 1 },
            { type: 'track', section: 'Избушка на курьих ножках (Баба-Яга)', trackNum: 26, duration: '3:08', indentLevel: 1 },
            { type: 'track', section: 'Богатырские ворота (В стольном городе во Киеве)', trackNum: 27, duration: '4:25', indentLevel: 1 },
        ],
    },
    {
        num: 16,
        authorTitle: 'Лядов. Баба-Яга',
        performer: 'Гос. академ. симф. орк. СССР. Дир. Светланов Е.',
        tracks: [{ trackNum: 28, duration: '3:32' }],
        rows: [{ type: 'track', section: 'Лядов. Баба-Яга', trackNum: 28, duration: '3:32', indentLevel: 0 }],
    },
    {
        num: 17,
        authorTitle: 'Лядов. Кикимора',
        performer: 'Гос. академ. симф. орк. СССР. Дир. Светланов Е.',
        tracks: [{ trackNum: 29, duration: '8:03' }],
        rows: [{ type: 'track', section: 'Лядов. Кикимора', trackNum: 29, duration: '8:03', indentLevel: 0 }],
    },
];

const TABLE_CONTENT_4_DISK9 = [
    {
        num: 18,
        authorTitle: 'Сен-Санс. «Карнавал животных»:',
        performer: 'Европейский фил. орк. Дир. Хемишер Гринберг',
        tracks: [
            { trackNum: 1, duration: '1:59' }, { trackNum: 2, duration: '1:08' }, { trackNum: 3, duration: '0:38' },
            { trackNum: 4, duration: '2:38' }, { trackNum: 5, duration: '1:58' }, { trackNum: 6, duration: '1:02' },
            { trackNum: 7, duration: '2:27' }, { trackNum: 8, duration: '0:44' }, { trackNum: 9, duration: '2:32' },
            { trackNum: 10, duration: '1:23' }, { trackNum: 11, duration: '1:30' }, { trackNum: 12, duration: '2:03' },
            { trackNum: 13, duration: '2:42' }, { trackNum: 14, duration: '1:49' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление и королевский марш львов', trackNum: 1, duration: '1:59', indentLevel: 1 },
            { type: 'track', section: 'Куры и петухи', trackNum: 2, duration: '1:08', indentLevel: 1 },
            { type: 'track', section: 'Антилопы', trackNum: 3, duration: '0:38', indentLevel: 1 },
            { type: 'track', section: 'Черепахи', trackNum: 4, duration: '2:38', indentLevel: 1 },
            { type: 'track', section: 'Слон', trackNum: 5, duration: '1:58', indentLevel: 1 },
            { type: 'track', section: 'Кенгуру', trackNum: 6, duration: '1:02', indentLevel: 1 },
            { type: 'track', section: 'Аквариум', trackNum: 7, duration: '2:27', indentLevel: 1 },
            { type: 'track', section: 'Осел', trackNum: 8, duration: '0:44', indentLevel: 1 },
            { type: 'track', section: 'Кукушка в лесу', trackNum: 9, duration: '2:32', indentLevel: 1 },
            { type: 'track', section: 'Птицы', trackNum: 10, duration: '1:23', indentLevel: 1 },
            { type: 'track', section: 'Пианисты', trackNum: 11, duration: '1:30', indentLevel: 1 },
            { type: 'track', section: 'Ископаемые', trackNum: 12, duration: '2:03', indentLevel: 1 },
            { type: 'track', section: 'Лебедь', trackNum: 13, duration: '2:42', indentLevel: 1 },
            { type: 'track', section: 'Финал', trackNum: 14, duration: '1:49', indentLevel: 1 },
        ],
    },
    {
        num: 19,
        authorTitle: 'Барток. «Микрокосмос»:',
        performer: 'Б. Шоколай',
        tracks: [
            { trackNum: 15, duration: '0:48' }, { trackNum: 16, duration: '0:40' }, { trackNum: 17, duration: '0:33' },
            { trackNum: 18, duration: '0:38' }, { trackNum: 19, duration: '0:33' }, { trackNum: 20, duration: '1:18' },
            { trackNum: 21, duration: '0:54' }, { trackNum: 22, duration: '1:05' }, { trackNum: 23, duration: '0:33' },
            { trackNum: 24, duration: '1:33' }, { trackNum: 25, duration: '1:01' }, { trackNum: 26, duration: '0:57' },
            { trackNum: 27, duration: '0:44' }, { trackNum: 28, duration: '1:15' }, { trackNum: 29, duration: '0:52' },
            { trackNum: 30, duration: '0:49' }, { trackNum: 31, duration: '0:56' }, { trackNum: 32, duration: '1:07' },
            { trackNum: 33, duration: '0:59' }, { trackNum: 34, duration: '1:19' }, { trackNum: 35, duration: '1:40' },
            { trackNum: 36, duration: '4:14' }, { trackNum: 37, duration: '2:10' }, { trackNum: 38, duration: '2:00' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'В лидийском ладу. Том 2, №37', trackNum: 15, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'На югославский лад. Т. 2, № 40', trackNum: 16, duration: '0:40', indentLevel: 1 },
            { type: 'track', section: 'Менуэт. Т. 2, №50', trackNum: 17, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: 'Сексты и терции. Т. 3, №№73', trackNum: 18, duration: '0:38', indentLevel: 1 },
            { type: 'track', section: 'Скерцо. Т. 3, № 82', trackNum: 19, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: 'Вариации. Т. 3, №87', trackNum: 20, duration: '1:18', indentLevel: 1 },
            { type: 'track', section: 'В стиле народной песни. Т. 4, № 100', trackNum: 21, duration: '0:54', indentLevel: 1 },
            { type: 'track', section: 'В болгарском ритме. Allegro. Т. 4, №113', trackNum: 22, duration: '1:05', indentLevel: 1 },
            { type: 'track', section: 'В болгарском ритме. Vivace. T. 4, № 115', trackNum: 23, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: 'Мелодия. Т. 4, №116', trackNum: 24, duration: '1:33', indentLevel: 1 },
            { type: 'track', section: 'Квинты. Т. 4, № 120', trackNum: 25, duration: '1:01', indentLevel: 1 },
            { type: 'track', section: 'Аккорды одновременно и чередуясь. Т. 5, № 122', trackNum: 26, duration: '0:57', indentLevel: 1 },
            { type: 'track', section: 'Переменный размер. Т. 5, № 126', trackNum: 27, duration: '0:44', indentLevel: 1 },
            { type: 'track', section: 'Крестьянский танец. Т. 5, №128', trackNum: 28, duration: '1:15', indentLevel: 1 },
            { type: 'track', section: 'Чередующиеся терции. Т. 5, № 129', trackNum: 29, duration: '0:52', indentLevel: 1 },
            { type: 'track', section: 'Деревенская шутка. Т. 5, № 130', trackNum: 30, duration: '0:49', indentLevel: 1 },
            { type: 'track', section: 'Кварты. Т. 5, №131', trackNum: 31, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'Синкопы. Т. 5, №133', trackNum: 32, duration: '1:07', indentLevel: 1 },
            { type: 'track', section: 'Вечное движение. Т. 5, № 135', trackNum: 33, duration: '0:59', indentLevel: 1 },
            { type: 'track', section: 'Волынка. Т. 5, № 138', trackNum: 34, duration: '1:19', indentLevel: 1 },
            { type: 'track', section: 'Свободные вариации. Т. 6, №140', trackNum: 35, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'Малые секунды. Большие септимы. Т. 6, №144', trackNum: 36, duration: '4:14', indentLevel: 1 },
            { type: 'track', section: 'Остинато. Т. 6, №146', trackNum: 37, duration: '2:10', indentLevel: 1 },
            { type: 'track', section: 'Марш. Т. 6, №147', trackNum: 38, duration: '2:00', indentLevel: 1 },
        ],
    },
    {
        num: 20,
        authorTitle: 'Прокофьев. Детская музыка:',
        performer: 'В. Жуков',
        tracks: [
            { trackNum: 39, duration: '3:01' }, { trackNum: 40, duration: '1:40' }, { trackNum: 41, duration: '1:04' },
            { trackNum: 42, duration: '1:33' }, { trackNum: 43, duration: '0:54' }, { trackNum: 44, duration: '0:53' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Сказочка', trackNum: 39, duration: '3:01', indentLevel: 1 },
            { type: 'track', section: 'Вальс', trackNum: 40, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'Шествие кузнечиков', trackNum: 41, duration: '1:04', indentLevel: 1 },
            { type: 'track', section: 'Дождь и радуга', trackNum: 42, duration: '1:33', indentLevel: 1 },
            { type: 'track', section: 'Пятнашки', trackNum: 43, duration: '0:54', indentLevel: 1 },
            { type: 'track', section: 'Марш', trackNum: 44, duration: '0:53', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_4_DISK10 = [
    { num: 1, authorTitle: 'Святки. Колядка №1. «А у етот двор пришла коляда»', performer: 'Деревня Марьино Глинковского района Смоленской области. Запись 1995 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 2, duration: '0:57' }], rows: [{ type: 'track', section: 'Святки. Колядка №1. «А у етот двор пришла коляда»', trackNum: 2, duration: '0:57', indentLevel: 0 }] },
    { num: 2, authorTitle: 'Колядка №2. «Уж ты, бабушка, подай»', performer: 'Фольклорная группа детского хора Всесоюзного Радио. Запись 1978 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 4, duration: '1:00' }], rows: [{ type: 'track', section: 'Колядка №2. «Уж ты, бабушка, подай»', trackNum: 4, duration: '1:00', indentLevel: 0 }] },
    { num: 3, authorTitle: 'Гадания: Подблюдная - «Как под Новый год».', performer: 'Деревня Белый Холм Глинковского района Смоленской области. Запись 1995 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 6, duration: '3:17' }], rows: [{ type: 'track', section: 'Гадания: Подблюдная - «Как под Новый год».', trackNum: 6, duration: '3:17', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Масленица.' }] },
    { num: 4, authorTitle: '«Мы Масленку дожидали»', performer: 'Деревня Велисто Духовщинского района Смоленской области. Запись 1997 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 8, duration: '0:49' }], rows: [{ type: 'track', section: '«Мы Масленку дожидали»', trackNum: 8, duration: '0:49', indentLevel: 0 }] },
    { num: 5, authorTitle: 'Проводы масленицы - «Масленая-кукурузка»', performer: 'Деревня Владимировка Рогнединского района Брянской области. Запись 1999 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 10, duration: '0:30' }], rows: [{ type: 'track', section: 'Проводы масленицы - «Масленая-кукурузка»', trackNum: 10, duration: '0:30', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Сороки.' }] },
    { num: 6, authorTitle: '«Жавороночки, перепелочки»', performer: 'Учащиеся ДМШ № 67 «Коньково» г. Москвы', tracks: [{ trackNum: 12, duration: '0:22' }], rows: [{ type: 'track', section: '«Жавороночки, перепелочки»', trackNum: 12, duration: '0:22', indentLevel: 0 }] },
    { num: 7, authorTitle: 'Песни заклички. «Благослови, Божа, нам вясну гукать»', performer: 'Деревня Липовка Шумячского района Смоленской области. Запись 1987 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 14, duration: '1:20' }], rows: [{ type: 'track', section: 'Песни заклички. «Благослови, Божа, нам вясну гукать»', trackNum: 14, duration: '1:20', indentLevel: 0 }] },
    { num: 8, authorTitle: 'Качели. «На Сороки девки колыхались-колыхались»', performer: 'Посёлок Глинка Глинковского района Смоленской области. Запись 1996 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 16, duration: '0:37' }], rows: [{ type: 'track', section: 'Качели. «На Сороки девки колыхались-колыхались»', trackNum: 16, duration: '0:37', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Пасха.' }] },
    { num: 9, authorTitle: '«Волочёбныя, люди добрыя»', performer: 'Деревня Лутна Клетнянского района Брянской области. Запись 1998 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 18, duration: '1:48' }], rows: [{ type: 'track', section: '«Волочёбныя, люди добрыя»', trackNum: 18, duration: '1:48', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Егорьев день.' }] },
    { num: 10, authorTitle: 'Егорьевская песня. «Батюшка Егорий»', performer: 'Деревня Копылово Кологривского района Костромской области. Запись 1975 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 20, duration: '0:22' }], rows: [{ type: 'track', section: 'Егорьевская песня. «Батюшка Егорий»', trackNum: 20, duration: '0:22', indentLevel: 0 }] },
    { num: 11, authorTitle: '«Ягорьюшка, наш батюшка»', performer: 'Деревня Марьино Глинковского района Смоленской области. Запись 1995 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 22, duration: '0:43' }], rows: [{ type: 'track', section: '«Ягорьюшка, наш батюшка»', trackNum: 22, duration: '0:43', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Троица. «Духовская» неделя.' }] },
    { num: 12, authorTitle: '«Пойдёмтя, девушки, у луги гуляти»', performer: 'Деревня Петрищево Духовщинского района Смоленской области. Запись 1997 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 24, duration: '1:00' }], rows: [{ type: 'track', section: '«Пойдёмтя, девушки, у луги гуляти»', trackNum: 24, duration: '1:00', indentLevel: 0 }] },
    { num: 13, authorTitle: '«Вянки завювали, сабе загадали»', performer: 'Деревня Мякуры Демидовского района Смоленской области. Запись 1984 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 26, duration: '0:36' }], rows: [{ type: 'track', section: '«Вянки завювали, сабе загадали»', trackNum: 26, duration: '0:36', indentLevel: 0 }] },
    { num: 14, authorTitle: '«Пойдёмтя, девки, по дорожке»', performer: 'Деревня Литвиново Рогнединского района Брянской области. Запись 1999 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 28, duration: '1:13' }], rows: [{ type: 'track', section: '«Пойдёмтя, девки, по дорожке»', trackNum: 28, duration: '1:13', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Праздник Ивана Купалы.' }] },
    { num: 15, authorTitle: '«Рано на Ивана солнышко играло».', performer: 'Деревня Литвиново Рогнединского района Брянской области. Запись 1999 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 30, duration: '0:39' }], rows: [{ type: 'track', section: '«Рано на Ивана солнышко играло».', trackNum: 30, duration: '0:39', indentLevel: 0 }] },
    { num: 16, authorTitle: '«Купаленка, купаленка, ночь маленька, купаленка»', performer: 'Деревня Осово Руднянского района Смоленской области. Запись 1988 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 32, duration: '1:12' }], rows: [{ type: 'track', section: '«Купаленка, купаленка, ночь маленька, купаленка»', trackNum: 32, duration: '1:12', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Жатва.' }] },
    { num: 17, authorTitle: 'Жнивные песни «А не заходи да ты, жаркая ж солнца»', performer: 'Деревня Рогово Почепского района Брянской области. Запись 2001 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 34, duration: '0:52' }], rows: [{ type: 'track', section: 'Жнивные песни «А не заходи да ты, жаркая ж солнца»', trackNum: 34, duration: '0:52', indentLevel: 0 }] },
    { num: 18, authorTitle: 'Конец жатвы: песня-величание «Слава тебе, Боже»', performer: 'Деревня Добрино Духовщинского района Смоленской области. Запись 1989 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 36, duration: '1:00' }], rows: [{ type: 'track', section: 'Конец жатвы: песня-величание «Слава тебе, Боже»', trackNum: 36, duration: '1:00', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Родинный ритуал. Родинные песни.' }] },
    { num: 19, authorTitle: 'Крестьбинская песнь «А ў кого виноград на дворе»', performer: 'Деревня Миганово Краснинского района Смоленской области. Запись 1997 г. Архив РАМ им. Гнесиных', tracks: [{ trackNum: 38, duration: '2:14' }], rows: [{ type: 'track', section: 'Крестьбинская песнь «А ў кого виноград на дворе»', trackNum: 38, duration: '2:14', indentLevel: 0 }] },
    { num: 20, authorTitle: 'Колыбельные. «А баю-баю, живеть мужик на краю»', performer: 'Деревня Титово Шаблыкинского района Орловской области. Запись 2000 г.', tracks: [{ trackNum: 40, duration: '0:26' }], rows: [{ type: 'track', section: 'Колыбельные. «А баю-баю, живеть мужик на краю»', trackNum: 40, duration: '0:26', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Деревенская свадьба.' }] },
    { num: 21, authorTitle: 'Девишник. «А в субботу да Танечка»', performer: 'Деревня Марьино Глинковского района Смоленской области. Запись 1995 г.', tracks: [{ trackNum: 42, duration: '1:03' }], rows: [{ type: 'track', section: 'Девишник. «А в субботу да Танечка»', trackNum: 42, duration: '1:03', indentLevel: 0 }] },
    { num: 22, authorTitle: 'Венок, «Немножечко венчику на стенке висеть»', performer: 'Деревня Марьино Глинковского района Смоленской области. Запись 1995 г.', tracks: [{ trackNum: 44, duration: '0:48' }], rows: [{ type: 'track', section: 'Венок, «Немножечко венчику на стенке висеть»', trackNum: 44, duration: '0:48', indentLevel: 0 }] },
    { num: 24, authorTitle: 'Благословление сына. «Ай Божа, Божа, я сына жаню»', performer: 'Деревня Белый Холм Глинковского района Смоленской области. Запись 1996 г.', tracks: [{ trackNum: 46, duration: '0:44' }], rows: [{ type: 'track', section: 'Благословление сына. «Ай Божа, Божа, я сына жаню»', trackNum: 46, duration: '0:44', indentLevel: 0 }] },
    { num: 25, authorTitle: 'Свадебный поезд. «Тихая пташечка соловей у саду»', performer: 'Деревня Петрищево Духовщинского района Смоленской области. Запись 1997 г.', tracks: [{ trackNum: 48, duration: '0:48' }], rows: [{ type: 'track', section: 'Свадебный поезд. «Тихая пташечка соловей у саду»', trackNum: 48, duration: '0:48', indentLevel: 0 }] },
    { num: 27, authorTitle: 'Выкуп, Застолье. «Шерой бор, шерой бор разгорается»', performer: 'Деревня Петрищево Духовщинского района Смоленской области. Запись 1997 г.', tracks: [{ trackNum: 50, duration: '0:48' }], rows: [{ type: 'track', section: 'Выкуп, Застолье. «Шерой бор, шерой бор разгорается»', trackNum: 50, duration: '0:48', indentLevel: 0 }] },
    { num: 27, authorTitle: '«Ох, не было ветру»', performer: 'Деревня Лутна Клетнянского района Брянской области. Запись 1998 г.', tracks: [{ trackNum: 52, duration: '0:35' }], rows: [{ type: 'track', section: '«Ох, не было ветру»', trackNum: 52, duration: '0:35', indentLevel: 0 }] },
    { num: 27, authorTitle: 'Величание. Застолье в доме жениха. «Ещё кто у нас в пиру хорош»', performer: 'Деревня Вяльцево Кологривского района Костромской области. Запись 1975 г.', tracks: [{ trackNum: 54, duration: '0:55' }], rows: [{ type: 'track', section: 'Величание. Застолье в доме жениха. «Ещё кто у нас в пиру хорош»', trackNum: 54, duration: '0:55', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Похороны.' }] },
    { num: 28, authorTitle: 'Похороны. Плач-причитание. «Ой тошнёшенько... Я проводила милу ладу»', performer: 'Деревня Раменье Тарногского района Вологодской области. Исполняет Анастасия Булатова. Запись 1975 г.', tracks: [{ trackNum: 56, duration: '1:25' }], rows: [{ type: 'track', section: 'Похороны. Плач-причитание. «Ой тошнёшенько... Я проводила милу ладу»', trackNum: 56, duration: '1:25', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Народные игры.' }] },
    { num: 29, authorTitle: '«Гори, гори ясно»', performer: 'Учащиеся ДМШ № 67 «Коньково» г. Москвы', tracks: [{ trackNum: 58, duration: '0:15' }], rows: [{ type: 'track', section: '«Гори, гори ясно»', trackNum: 58, duration: '0:15', indentLevel: 0 }] },
    { num: 30, authorTitle: '«Горшун, Горшун - дедушка»', performer: 'Учащиеся ДМШ № 67 «Коньково» г. Москвы', tracks: [{ trackNum: 59, duration: '0:40' }], rows: [{ type: 'track', section: '«Горшун, Горшун - дедушка»', trackNum: 59, duration: '0:40', indentLevel: 0 }] },
    { num: 31, authorTitle: '«Заплетися, плетень»', performer: 'Фольклорная группа детского хора Всесоюзного Радио. Запись 1978 г.', tracks: [{ trackNum: 62, duration: '0:42' }], rows: [{ type: 'track', section: '«Заплетися, плетень»', trackNum: 62, duration: '0:42', indentLevel: 0 }] },
    { num: 32, authorTitle: 'Святочные игры. «Искупался Иванушко»', performer: 'Учащиеся ДМШ № 67 «Коньково» г. Москвы', tracks: [{ trackNum: 64, duration: '0:20' }], rows: [{ type: 'track', section: 'Святочные игры. «Искупался Иванушко»', trackNum: 64, duration: '0:20', indentLevel: 0 }] },
    { num: 33, authorTitle: 'Хороводы. «Эй, ходит царь»', performer: 'Деревня Болотня Клетнянского района Брянской области. Запись 1998 г.', tracks: [{ trackNum: 66, duration: '1:09' }], rows: [{ type: 'track', section: 'Хороводы. «Эй, ходит царь»', trackNum: 66, duration: '1:09', indentLevel: 0 }] },
    { num: 34, authorTitle: 'Былины. «О Добрыне Никитиче»', performer: 'Ансамбль «Русичи» п/у Б. Базурова. Исполняет Б. Базуров.', tracks: [{ trackNum: 68, duration: '1:50' }], rows: [{ type: 'track', section: 'Былины. «О Добрыне Никитиче»', trackNum: 68, duration: '1:50', indentLevel: 0 }] },
    { num: 0, authorTitle: '', performer: '', tracks: [], rows: [{ type: 'subheading', section: 'Народные инструменты.' }] },
    { num: 35, authorTitle: 'Охотничьи манки', performer: 'Посёлок Островское Островского района Костромской области. Исполняет Г.К. Стрелков.', tracks: [{ trackNum: 70, duration: '0:57' }], rows: [{ type: 'track', section: 'Охотничьи манки', trackNum: 70, duration: '0:57', indentLevel: 0 }] },
    { num: 36, authorTitle: 'Рога.', performer: 'Запись 1989 г. Личный архив Т.В. Кирюшиной.', tracks: [{ trackNum: 72, duration: '0:10' }], rows: [{ type: 'track', section: 'Рога.', trackNum: 72, duration: '0:10', indentLevel: 0 }] },
    { num: 37, authorTitle: 'Сигнал дула ружья', performer: 'Посёлок Островское Островского района Костромской области. Исполняет Г.К. Стрелков. Запись 1989 г. Личный архив Т.В. Кирюшиной.', tracks: [{ trackNum: 74, duration: '0:13' }], rows: [{ type: 'track', section: 'Сигнал дула ружья', trackNum: 74, duration: '0:13', indentLevel: 0 }] },
    { num: 38, authorTitle: 'Пастушьи колокольчики', performer: 'Посёлок Островское Островского района Костромской области. Исполняет Г.К. Стрелков.', tracks: [{ trackNum: 76, duration: '0:15' }], rows: [{ type: 'track', section: 'Пастушьи колокольчики', trackNum: 76, duration: '0:15', indentLevel: 0 }] },
    { num: 39, authorTitle: 'Плясовой наигрыш на двойной жалейке', performer: 'Село Серапиха Чухломского района Костромской области. Показывает Б.А. Попов.', tracks: [{ trackNum: 78, duration: '0:24' }], rows: [{ type: 'track', section: 'Плясовой наигрыш на двойной жалейке', trackNum: 78, duration: '0:24', indentLevel: 0 }] },
    { num: 40, authorTitle: 'Пастуший барабан, сгонный сигнал', performer: 'Село Афанасьевка Алексеевского района Белгородской области.', tracks: [{ trackNum: 80, duration: '0:30' }], rows: [{ type: 'track', section: 'Пастуший барабан, сгонный сигнал', trackNum: 80, duration: '0:30', indentLevel: 0 }] },
    { num: 41, authorTitle: 'Праздничный колокольный звон', performer: 'Деревня Тарасиха Нижегородской области.', tracks: [{ trackNum: 82, duration: '0:20' }], rows: [{ type: 'track', section: 'Праздничный колокольный звон', trackNum: 82, duration: '0:20', indentLevel: 0 }] },
    { num: 42, authorTitle: 'Бубенчики', performer: 'Село Коровье Чухломского района Костромской области.', tracks: [{ trackNum: 84, duration: '0:10' }], rows: [{ type: 'track', section: 'Бубенчики', trackNum: 84, duration: '0:10', indentLevel: 0 }] },
    { num: 43, authorTitle: 'Кугиклы. Плясовой наигрыш «Жарко пахать»', performer: 'Село Плёхово Суджанского района Курской области.', tracks: [{ trackNum: 86, duration: '0:23' }], rows: [{ type: 'track', section: 'Кугиклы. Плясовой наигрыш «Жарко пахать»', trackNum: 86, duration: '0:23', indentLevel: 0 }] },
    { num: 44, authorTitle: 'Дудки и коса. Наигрыш «Наши шли, зажинать пошли»', performer: 'Село Нижние Пены Ракитянского района Белгородской области.', tracks: [{ trackNum: 88, duration: '0:17' }], rows: [{ type: 'track', section: 'Дудки и коса. Наигрыш «Наши шли, зажинать пошли»', trackNum: 88, duration: '0:17', indentLevel: 0 }] },
    { num: 45, authorTitle: 'Гусли. Наигрыш «горбатого»', performer: 'Псковская область. Исполняет Т. Тимофеев.', tracks: [{ trackNum: 90, duration: '0:28' }], rows: [{ type: 'track', section: 'Гусли. Наигрыш «горбатого»', trackNum: 90, duration: '0:28', indentLevel: 0 }] },
    { num: 46, authorTitle: 'Скрипка. Свадебный марш.', performer: 'Скрипачи Смоленского и Починковского районов Смоленской области - Ф.А. Щербина, Г.Н. Бобынин.', tracks: [{ trackNum: 92, duration: '0:23' }], rows: [{ type: 'track', section: 'Скрипка. Свадебный марш.', trackNum: 92, duration: '0:23', indentLevel: 0 }] },
    { num: 47, authorTitle: 'Балалайка. «Под пляску»', performer: 'Город Кологрив Костромской области.', tracks: [{ trackNum: 94, duration: '0:17' }], rows: [{ type: 'track', section: 'Балалайка. «Под пляску»', trackNum: 94, duration: '0:17', indentLevel: 0 }] },
    { num: 48, authorTitle: 'Гармошечный. «Под проходку»', performer: 'Посёлок Островское Островского района Костромской области. Исполняет П.В. Беляев. Запись 1989 г. Личный архив Т.В. Кирюшиной.', tracks: [{ trackNum: 95, duration: '0:26' }], rows: [{ type: 'track', section: 'Гармошечный. «Под проходку»', trackNum: 95, duration: '0:26', indentLevel: 0 }] },
];

const TABLE_CONTENT_4 = {
    1: TABLE_CONTENT_4_DISK1,
    2: TABLE_CONTENT_4_DISK2,
    3: TABLE_CONTENT_4_DISK3,
    4: TABLE_CONTENT_4_DISK4,
    5: TABLE_CONTENT_4_DISK5,
    6: TABLE_CONTENT_4_DISK6,
    7: TABLE_CONTENT_4_DISK7,
    8: TABLE_CONTENT_4_DISK8,
    9: TABLE_CONTENT_4_DISK9,
    10: TABLE_CONTENT_4_DISK10,
};

export { TABLE_CONTENT_4 };
